import React from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import useTheme from '@mui/styles/useTheme';
import { useTranslation } from 'react-i18next';
import { locales } from '../../utils/formatters';
import FooterLink from './FooterLink';
import FooterRow from './FooterRow';
import FooterItem from './FooterItem';
import FooterColumn from './FooterColumn';
import useAuth from '../../authentication/useAuth';
import { FOOTER_NAVLINKS } from '../../constants/Footer';

function Footer({ message, allowContact }) {
	const { t } = useTranslation('footer');
	const theme = useTheme();
	const year = new Date().getFullYear();
	const { getCurrentUser } = useAuth();
	const currentUser = getCurrentUser();
	const footerTextSizeSm = theme.palette.textSize.sizeSm;
	const footerTextSizeXs = theme.palette.textSize.sizeXs;

	const footerLinks = FOOTER_NAVLINKS;

	const styles = {
		container: {
			padding: `${theme.spacing(0.75)} ${theme.spacing(4)}`,
			backgroundColor: theme.palette.base.light,
		},
		linkRowColumn: {
			color: theme.palette.link.main,
		},
		linkRowGap: '.5rem .75rem',
		linkText: {
			fontSize: footerTextSizeSm,
		},
		linkIcon: {
			fontSize: footerTextSizeXs,
		},
		trademarkText: {
			fontSize: footerTextSizeXs,
		},
	};

	const centerColumn = (
		<FooterColumn wrap gap={styles.linkRowGap} sx={styles.linkRowColumn}>
			{footerLinks.map((navLink) => (
				<FooterItem key={navLink.label}>
					<FooterLink
						href={navLink.href}
						className={navLink.className}
						label={t(`${navLink.label}`)}
						ariaLabel={t(`${navLink.label}`)}
						icon={navLink.icon}
						fontSize={styles.linkText.fontSize}
						iconFontSize={styles.linkIcon.fontSize}
					/>
				</FooterItem>
			))}
		</FooterColumn>
	);

	const rightColumn = undefined;

	const trademarkColumn = (
		<FooterColumn>
			<FooterItem>
				<Typography sx={styles.trademarkText}>
					{t('trademark', { year })}
				</Typography>
			</FooterItem>
		</FooterColumn>
	);

	return (
		<footer style={styles.container}>
			<FooterRow center={centerColumn} right={rightColumn} />
			<FooterRow tight center={trademarkColumn} />
		</footer>
	);
}
Footer.propTypes = {
	message: PropTypes.string,
	allowContact: PropTypes.string,
};

export default Footer;
